import EditableProMode from 'components/Editor/cource/layout/controls/ElementControls/EditableProMode'
import TestElementChangeStateActions from 'components/Editor/cource/layout/controls/ElementControls/TestElementChangeState'
import Separator from 'components/Editor/cource/layout/controls/Separator'
import { AppMode } from 'services/Store/Project/enums'

import type {
  TestKeyboardInputStateType,
  TestKeyboardInputEditorActionsType,
} from './testKeyboardInputTypes'

const TestKeyboardInputEditorActions: TestKeyboardInputEditorActionsType = ({
  element: { value },
  setState,
  customMode,
  mode,
  state,
  setAppMode,
}) => {
  const isPro = mode.editorMode === AppMode.pro
  return (
    <>
      {isPro && <EditableProMode customMode={customMode} mode={mode} setAppMode={setAppMode} />}
      {isPro && value.displayFeedback && <Separator />}
      <TestElementChangeStateActions<TestKeyboardInputStateType>
        setState={setState}
        state={state}
        value={value}
      />
    </>
  )
}

export default TestKeyboardInputEditorActions
